import React, { Suspense, lazy } from 'react';

function ScreenFallback() {
	return (
		<div className="min-h-[40vh] bg-white flex items-center justify-center">
			<div className="text-center">
				<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" />
				<p className="text-gray-600">Loading...</p>
			</div>
		</div>
	);
}

export default function createDeferredScreen(importer) {
	const LazyComponent = lazy(importer);

	function DeferredScreen(props) {
		return (
			<Suspense fallback={<ScreenFallback />}>
				<LazyComponent {...props} />
			</Suspense>
		);
	}

	return DeferredScreen;
}
